<template>
<div class="section section-solutions align-center has-shadow">
        <div class="section__header">
            <h1 class="headline section__header__headline">{{ sectionPlansContent.title }}</h1>
            <span class="section__header__tagline">{{ sectionPlansContent.sub_title }}</span>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xs-12 col-md-4 col-lg-4 solution" v-for="plan in plans" :key="plan.id">
                    <object ref="mySVG" :id="plan.id" type="image/svg+xml" width="300px" :data="plan.image_url"></object>
                    <div class="solution__desc has-shadow">
                        <h1 class="headline section__header__headline">{{ plan.title }}</h1>
                        <p class="tagline section__header__tagline">{{ plan.content }}</p>
                        <router-link :to="{ path: $parent.$parent.$i18n.locale + plan.url }" class="button button--primary">
                          <span class="button--primary__text">{{ $t("global.getAnEstimation") }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Vivus from "vivus";

Object.defineProperty(Vue.prototype, "$Vivus", { value: Vivus });

export default {
	name: "Skills",
	data() {
		return {
			sectionPlansContent: {},
			plans: []
		};
	},
	mounted() {
		this.getAll();
	},
	methods: {
		getAll() {
			this.$http
				.get(
					this.$parent.$parent.$parent.apiURL +
						"/textblocks?filter[name]=homepage-section-plans-content"
				)
				.then(function(response) {
					this.sectionPlansContent = response.body;
				});

			this.$http
				.get(
					this.$parent.$parent.$parent.apiURL +
						"/textblocks/text-blocks-widgets?filter[name]=homepage-section-plans"
				)
				.then(function(response) {
					this.plans = response.body.widget_blocks;
				});
		}
	}
};
</script>

<style scoped>
@media (max-width: 46.25em) {
	.section-solutions .solution object {
		left: 0;
		top: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Plans.vue